var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFundingicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#45372A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6933 4.81953C12.8523 4.63658 13.0992 4.55617 13.3355 4.61041C16.4932 5.33536 18.0893 8.79565 17.714 11.8915C17.5681 13.095 17.2076 14.0384 16.6768 14.7891C16.6735 14.7937 16.6703 14.7983 16.667 14.8028C16.7876 14.7436 16.8988 14.6796 17.0029 14.6121C17.5208 14.2759 17.901 13.8323 18.3959 13.2546C18.4558 13.1848 18.5173 13.113 18.5809 13.0392C18.7239 12.8734 18.9401 12.7898 19.1575 12.8164C19.3748 12.8429 19.5646 12.9761 19.6634 13.1715C20.0988 14.0318 20.3438 15.0044 20.3438 16.0323C20.3438 19.5359 17.5036 22.3761 14 22.3761C10.4964 22.3761 7.65625 19.5359 7.65625 16.0323C7.65625 13.8124 8.79699 11.8593 10.5213 10.7267L10.5804 10.6671C10.6108 10.6365 10.6441 10.609 10.6798 10.5849C11.4375 10.0751 11.9815 9.65813 12.3477 9.16775C12.6937 8.70451 12.9062 8.13942 12.9062 7.28231C12.9062 6.64769 12.7891 6.04198 12.5758 5.48457C12.4891 5.25819 12.5343 5.00249 12.6933 4.81953ZM14.1498 6.34446C14.1952 6.65069 14.2188 6.96388 14.2188 7.28231C14.2188 8.39217 13.932 9.23995 13.3993 9.95317C12.899 10.623 12.2065 11.1374 11.4666 11.6374L11.4033 11.7012C11.3694 11.7353 11.3319 11.7656 11.2913 11.7916C9.89317 12.6867 8.96875 14.2518 8.96875 16.0323C8.96875 18.811 11.2213 21.0636 14 21.0636C16.7787 21.0636 19.0312 18.811 19.0312 16.0323C19.0312 15.5775 18.971 15.1373 18.8583 14.7189C18.5256 15.0792 18.1584 15.4268 17.7175 15.713C16.9096 16.2373 15.8987 16.5366 14.4375 16.5366C14.138 16.5366 13.8765 16.3339 13.8019 16.0439C13.7273 15.7538 13.8585 15.4501 14.1208 15.3056C14.7148 14.9784 15.2183 14.5783 15.6051 14.0313C15.9912 13.4853 16.287 12.7564 16.411 11.7335C16.6795 9.51913 15.7631 7.33343 14.1498 6.34446Z",
    fill: "#04D9FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundingicon);
export default __webpack_public_path__ + "static/media/fundingicon.d9588c8d592e78739d9f1586a941f506.svg";
export { ForwardRef as ReactComponent };